import { LitElement, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { provide } from '@lit/context';
import { GoonAPIClient } from '../client/ApiClient';
import { API_ENDPOINT } from '../constants';
import { authContext, AuthState } from '../context/AuthContext';

const api = new GoonAPIClient(API_ENDPOINT);

@customElement('auth-provider')
export class AuthProvider extends LitElement {

  @provide({ context: authContext })
  @property({attribute: false})
  public auth: AuthState = { user: null, userId: null };

  async checkAuth() {
    try {
      const user = await api.getCurrentUserProfile();
      this.auth = { user, userId: user.id };
    } catch {
      this.auth = { user: null, userId: null };
    }
  }

  async connectedCallback() {
    super.connectedCallback();
    await this.checkAuth()

    window.addEventListener('auth-state-changed', () => this.checkAuth());
  }

  disconnectedCallback() {
    window.removeEventListener('auth-state-changed', () => this.checkAuth());
    super.disconnectedCallback();
  }

    render() {
    return html`
      <slot></slot>
    `
  }
}

